import { makeStyles } from '@material-ui/core';
import { COLORS } from 'constants/index';
import { FONTS } from '../../../../constants';

export default makeStyles(theme => ({
    textField: {
        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: COLORS.apariBlack20
        },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused.Mui-error .MuiOutlinedInput-notchedOutline':
            {
                borderColor: theme.palette.error.main
            },
        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
        },
        '& .MuiInput-underline:before': {
            borderColor: COLORS.apariBlack20
        },
        '& .MuiFormLabel-root.Mui-disabled': {
            color: COLORS.apariBlack20
        },
        '& .MuiInputBase-root.Mui-disabled': {
            borderColor: COLORS.apariBlack20,
            color: COLORS.apariBlack20
        },
        '& .MuiInputBase-input.Mui-disabled': {
            borderColor: COLORS.apariBlack20,
            color: COLORS.apariBlack20
        }
    },
    disabledInput: {
        '& .MuiInputBase-input.Mui-disabled': {
            borderColor: COLORS.apariBlack20
        }
    },
    disableHover: {
        '&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: COLORS.apariBlack20
        }
    },
    autofillDark: {
        '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px ' + COLORS.apariBlack20 + ' inset',
            WebkitTextFillColor: COLORS.paperLight + ' !important'
        }
    },
    autofill: {
        '&:-webkit-autofill': {
            transition: 'background-color 5000s ease-in-out 0s',
            '&:disabled': {
                WebkitTextFillColor: COLORS.apariBlack20 + ' !important'
            }
        }
    },
    textFieldDarkBackground: {},
    inputLabel: {
        color: COLORS.apariBlack60,
        fontSize: 12
    },
    inputLabelFocused: {
        color: COLORS.apariBlack60 + ' !important',
        fontSize: 12
    },
    inputLabelShrink: {
        transform: 'translate(14px, -5px) scale(0.75) !important'
    },
    alternativeFont: {
        fontFamily: FONTS.QUATERNARY_FONT
    }
}));
